import React from "react";
import PropTypes from "prop-types";

import * as Theme from "../../../../App/Theme";

import GBStdChart from "../../../../Library/Charts/GBStdChart";
import TComboBox from "../../../../Library/ComboBoxes/TComboBox";
import TLabel from "../../../../Library/Labels/TLabel";

import { shouldComponentUpdateGB } from "../../../GB/NonComponents/GBUtil";

import * as DMConst from "../../NonComponents/DMConst";
import { getYearIdx } from "../../NonComponents/DMUtil";
import { getVMMC_TargCov1DFltArray } from "../../NonComponents/DMDataUtil";
import { API_URL_BASE, DMService } from "../../../../API/server_calls";
import TButton from "../../../../Library/Buttons/TButton";

class DMMalePopByAgeGroupForm extends React.Component {
    static propTypes = {
        navComboBoxHeight: PropTypes.number,
        results: PropTypes.object,
        selectedCountryMstID: PropTypes.number,
        selectedFiscalYearStart: PropTypes.number,
        selectedProvinceCurrID: PropTypes.number,
        selectedSNU_CurrID: PropTypes.number,
        selectedTargetYear: PropTypes.number,
        showGlobalOutputsBool: PropTypes.bool,
        VMMC_Coverage: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
    };

    static defaultProps = {
        navComboBoxHeight: 35,
        results: {},
        selectedCountryMstID: 1,
        selectedFiscalYearStart: DMConst.janFYS,
        selectedProvinceCurrID: 1,
        selectedSNU_CurrID: 1,
        selectedTargetYear: 0,
        showGlobalOutputsBool: false,
        VMMC_Coverage: [],
    };

    constructor(props) {
        super(props);

        this.state = {
            chartVsTable: DMConst.showChart,
            finalYear: DMConst.lastYearProgData,
        };
    }

    /* Avoid re-rendering if we don't have to (if no props or state affect this form). */
    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdateGB(this.props, nextProps, this.state, nextState);
    }

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    onDownloadResultTableBtnClick = () => {
        try {
            const props = this.props;
            const selectedCountryMstID = props.selectedCountryMstID;
            const selectedFiscalYearStart = props.selectedFiscalYearStart;
            const selectedProvinceCurrID = props.selectedProvinceCurrID;
            const selectedSNU_CurrID = props.selectedSNU_CurrID;
            const selectedTargetYear = props.selectedTargetYear;
            const showGlobalOutputsBool = props.showGlobalOutputsBool;
            const VMMC_Coverage = props.VMMC_Coverage;

            DMService.generateResultLink(
                "result_output",
                16,
                selectedCountryMstID,
                selectedProvinceCurrID,
                selectedSNU_CurrID,
                selectedTargetYear,
                getVMMC_TargCov1DFltArray(VMMC_Coverage),
                true,
                showGlobalOutputsBool,
                selectedFiscalYearStart,

                (result) => {
                    let a = document.createElement("a");
                    a.href = API_URL_BASE + "/" + result;
                    a.download = "result_output.xlsx";
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                },
                () => {
                    alert("Could not download result.");
                }
            );
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onFinalYearComboBoxChange = (value, text, info) => {
        try {
            this.setState({
                finalYear: text,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {
        try {
            const props = this.props;
            const results = props.results;
            const res = results[DMConst.rResult16];
            const selectedSNU_CurrID = props.selectedSNU_CurrID;
            const navComboBoxHeight = props.navComboBoxHeight;

            const state = this.state;
            const finalYear = state.finalYear;

            const pointLabels = res[DMConst.rPointLabels];
            const subsetLabels = res[DMConst.rSubsetLabels];
            const data4 = res[DMConst.rData4];
            const SNU_DataCirc = data4[1][selectedSNU_CurrID];
            const SNU_DataUncirc = data4[2][selectedSNU_CurrID];
            const yAxisLabel = res[DMConst.rYAxisLabel];
            const numPoints = res[DMConst.rPoints];

            const t2 = getYearIdx(finalYear);

            /* xAxis point labels */
            let categories = [];
            for (let pt = 1; pt <= numPoints; pt++) {
                categories.push(pointLabels[pt]);
            }

            let series = [
                {
                    name: subsetLabels[1],
                    data: [],
                },
                {
                    name: subsetLabels[2],
                    data: [],
                },
            ];

            /* Note that we do +1 on t2 + 1 because "End of year XXXX" is equivalent to "Year XXXX + 1". */
            for (let a = 1; a <= numPoints; a++) {
                series[0].data.push(SNU_DataCirc[a][t2 + 1]);
                series[1].data.push(SNU_DataUncirc[a][t2 + 1]);
            }

            const chartOptions = {
                chart: {
                    type: "bar",
                },

                title: {
                    text: res.title,
                    x: -20,
                },

                xAxis: {
                    categories: categories,
                },

                yAxis: {
                    title: {
                        text: yAxisLabel,
                    },

                    tickAmount: 10,

                    plotLines: [
                        {
                            value: 0,
                            width: 1,
                            color: "#808080",
                        },
                    ],

                    reversedStacks: false,

                    labels: {
                        format: "{value:,.0f}",
                    },
                },

                plotOptions: {
                    bar: {
                        stacking: true,
                    },

                    series: {
                        dataLabels: {
                            enabled: true,
                            inside: true,
                            formatter: function () {
                                return this.percentage.toFixed(0) + "%";
                            },
                        },
                    },
                },

                credits: {
                    text: "",
                },

                legend: {
                    layout: "horizontal",
                    align: "center",
                    verticalAlign: "top",
                    borderWidth: 0,
                    y: 20,
                },

                tooltip: {
                    //shared     : true,
                },

                roundForDownloadCSV: true,

                colors: Theme.DM_ChartColors,

                series: series,
            };

            const chart = (
                <GBStdChart
                    chartType={"bar"}
                    id={DMConst.rResult16}
                    key={Date.now()}
                    options={chartOptions}
                    style={{
                        bottom: Theme.configDivStyle.height,
                        left: 0,
                        overflow: "hidden",
                        position: "absolute",
                        right: 0,
                        top: navComboBoxHeight,
                    }}
                />
            );

            const finalYearLabel = (
                <TLabel
                    caption={"End of"}
                    style={{
                        marginLeft: 30,
                    }}
                />
            );

            let year1DIntArray = [];

            for (let t = DMConst.firstYear; t <= DMConst.lastPossibleTargetYear; t++) {
                year1DIntArray.push(t);
            }

            const finalYearComboBox = (
                <TComboBox
                    onChange={this.onFinalYearComboBoxChange}
                    itemIndex={finalYear - DMConst.firstYear}
                    items={year1DIntArray}
                    outerStyle={{
                        marginLeft: 5,
                        width: Theme.finalYearComboBoxWidth,
                    }}
                    style={Theme.finalYearComboBoxStyle}
                />
            );

            const downloadResultTableBtn = (
                <TButton
                    caption={"Download result table"}
                    onClick={this.onDownloadResultTableBtnClick}
                    containerStyle={{
                        marginLeft: Theme.indent * 3,
                    }}
                />
            );

            const configLeftDiv = (
                <div style={Theme.configLeftDivStyle}>
                    {finalYearLabel}
                    {finalYearComboBox}
                    {/*{downloadResultTableBtn}*/}
                </div>
            );

            const configDiv = <div style={Theme.configDivStyle}>{configLeftDiv}</div>;

            const resultDiv = (
                <div
                    style={Theme.resultCenterDiv}
                    key={"resultDiv"}
                >
                    {chart}
                </div>
            );

            return (
                <div key={"DMMalePopByAgeGroupFormDiv"}>
                    {resultDiv}
                    {configDiv}
                </div>
            );
        } catch (exception) {
            return (
                <div
                    className={"DMMalePopByAgeGroupFormDiv"}
                    key={"DMMalePopByAgeGroupFormDiv"}
                >
                    <h3 key={"DMMalePopByAgeGroupFormDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default DMMalePopByAgeGroupForm;
